/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontHome_seller = {
    readonly " $fragmentRefs": FragmentRefs<"StorefrontAboutSection_seller" | "StorefrontMediaSection_seller" | "StorefrontFeaturedSection_seller">;
    readonly " $refType": "StorefrontHome_seller";
};
export type StorefrontHome_seller$data = StorefrontHome_seller;
export type StorefrontHome_seller$key = {
    readonly " $data"?: StorefrontHome_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontHome_seller">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontHome_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontAboutSection_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontMediaSection_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontFeaturedSection_seller",
      "args": null
    }
  ]
};
(node as any).hash = 'b16ca51935fb6950d6a70543ba12ca26';
export default node;
